import { connect } from 'react-redux'
import BillingAccountFormAddressStep from './BillingAccountFormAddressStep'

const stateToProps = () => ({})

const dispatchToProps = {}

export default connect(stateToProps, dispatchToProps)(BillingAccountFormAddressStep)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingAccountFormAddressStep/BillingAccountFormAddressStep.container.js